import { useNavigate } from 'react-router-dom'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavItem } from 'reactstrap'
import { FaUser } from 'react-icons/fa'
import { getLoginItem, signOut } from '../../utils'

export default function UserMenu() {
  console.log('UserMenu rendered')
  const navigate = useNavigate()

  async function handleSignOut() {
    console.log('UserMenu.handleSignOut')
    signOut()
    window.apolloClient.onResetStore(() => console.log('Apollo store has been reset.'))
    await window.apolloClient.stop()
    await window.apolloClient.resetStore()
    window.location.reload()
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret>
        <b data-cy="user-menu-user-name"><FaUser style={{ verticalAlign: 'baseline' }} /> {getLoginItem('name')}</b>
      </DropdownToggle>
      <DropdownMenu end data-cy="user-menu">
        <DropdownItem>
          <NavItem data-cy="user-menu-user-profile-item" onClick={() => navigate('/userProfile')}>
            User Profile
          </NavItem>
        </DropdownItem>
        <DropdownItem>
          <NavItem data-cy="user-menu-sign-out-item" onClick={() => handleSignOut()}>
            Sign Out
          </NavItem>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
